var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleDoubleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.91,
    height: 20,
    viewBox: "0 0 24.91 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_angle-double-left",
    "data-name": "solid angle-double-left",
    d: "M37.1,104.888l8.5-8.5a1.493,1.493,0,0,1,2.118,0L49.126,97.8a1.493,1.493,0,0,1,0,2.118l-6.017,6.029,6.023,6.023a1.493,1.493,0,0,1,0,2.118L47.72,115.51a1.493,1.493,0,0,1-2.118,0l-8.5-8.5A1.5,1.5,0,0,1,37.1,104.888Zm-12,2.124,8.5,8.5a1.493,1.493,0,0,0,2.118,0L37.13,114.1a1.493,1.493,0,0,0,0-2.118l-6.017-6.029,6.023-6.023a1.493,1.493,0,0,0,0-2.118L35.724,96.39a1.493,1.493,0,0,0-2.118,0l-8.5,8.5A1.5,1.5,0,0,0,25.1,107.012Z",
    transform: "translate(-24.662 -95.95)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleIcon);
export default __webpack_public_path__ + "static/media/angle-double-icon.5749aa46e0d0568ce9bde28a3e456756.svg";
export { ForwardRef as ReactComponent };